import { Radio } from "antd";
import React, { useState, useEffect } from "react";
import Service from "services/service";
import { globalStore } from "stores/globalStore";
import AddressModal from "./AddressModal";
import homeadd from "../assets/Images/homeadd.png";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

function AddressDetails() {
  const { addressPageData, setAddressPageData } = globalStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editAddress, setEditAddress] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
    mobileNumber: "",
    Type: "HOME",
    default: false,
  });

  const fetchAddresses = async () => {
    setIsLoading(true);
    try {
      const response = await Service.getAllAddress();
      if (response.data.meta.code === 200) {
        setAddressPageData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  useEffect(() => {
    if (Array.isArray(addressPageData) && addressPageData.length > 0) {
      let defaultAddr = addressPageData.find((address) => address.default);
  
      // If no default address is found, set the first address as the default
      if (!defaultAddr) {
        defaultAddr = addressPageData[0];
        setSelectedAddress(defaultAddr._id);
        handleSelectAddress(defaultAddr._id); // Automatically update shipping address
      } else {
        setSelectedAddress(defaultAddr._id);
        handleSelectAddress(defaultAddr._id); // Automatically update shipping address
      }
    }
  }, [addressPageData]);

  const handleAddNew = () => {
    setEditAddress(null);
    setFormData({
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      pinCode: "",
      country: "",
      mobileNumber: "",
      Type: "HOME",
      default: false,
    });
    setIsModalOpen(true);
  };

  const handleEditAddress = async (id) => {
    try {
      const response = await Service.getAddressById(id);
      setEditAddress(id);
      setFormData(response.data.data);
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const handleSaveAddress = async () => {
    try {
      if (editAddress) {
        // Update existing address
        const response = await Service.updateAddress(formData, editAddress);
        if (response.data.meta.code === 200) {
          const updatedAddresses = addressPageData.map((address) =>
            address._id === editAddress ? { ...address, ...formData } : address
          );
          setAddressPageData(updatedAddresses);
        }
      } else {
        // Add new address
        const response = await Service.saveAddress(formData);
        showSuccessToast("New Address Saved Successfully !");

        const newAddress = response.data.data;
        setAddressPageData([...addressPageData, newAddress]);
      }
    } catch (error) {
      console.error("Error saving address:", error);
    } finally {
      setIsModalOpen(false);
    }
  };

  const handleRemoveAddress = async (id) => {
    try {
      const response = await Service.deleteAddress(id);
      if (response.data.meta.code === 200) {
        const updatedAddresses = addressPageData.filter(
          (address) => address._id !== id
        );
        setAddressPageData(updatedAddresses);
        if (selectedAddress === id) {
          setSelectedAddress(null);
        }
      }
    } catch (error) {
      console.error("Error removing address:", error);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setFormData({
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      pinCode: "",
      country: "",
      mobileNumber: "",
      Type: "HOME",
      default: false,
    });
  };

  const handleSelectAddress = async (id) => {
    try {
      setSelectedAddress(id);
      const payload = {
        shippingAddressId: id,
      };
      const response = await Service.updateShippingAddress(payload);
      if (response.data.meta.code === 200) {
        console.log("Shipping address updated successfully!");
      } else {
        console.error(
          "Failed to update shipping address:",
          response.data.meta.message
        );
      }
    } catch (error) {
      console.error("Error updating shipping address:", error);
    }
  };

  return (
    <div className="address__discount">
      <div className="address__add-new">
        <div className="address__discount-row">
          <img
            src={homeadd}
            alt="Discount Icon"
            className="address__discount-icon"
          />
          <h1 className="address__delivery-title ui heading size-headingmd">
            Select Delivery Address
          </h1>
        </div>
        <button
          className="flex-row-center-center address__add-button ui button white_a700 size-sm fill"
          onClick={handleAddNew}
        >
          ADD NEW ADDRESS
        </button>
      </div>

      {isLoading ? (
        // Display a loading spinner or message
        <div className="address__loading">
          <p>Loading addresses...</p>
        </div>
      ) : Array.isArray(addressPageData) && addressPageData.length > 0 ? (
        addressPageData.map((e) => (
          <div className="address__info" key={e._id}>
            <div className="address__user-details">
              <Radio
                checked={selectedAddress === e._id}
                onChange={() => handleSelectAddress(e._id)}
                className="address__radio-button"
              />
              <div className="address__user-row">
                <button className="flex-row-center-center address__home-button ui button teal_400 size-xs outline">
                  {e.Type}
                </button>
              </div>
              <div className="address__address-column">
                <div className="address__address-details">
                  <p className="address__mobile-text ui text size-text2xl">
                    {e.addressLine1}
                  </p>
                  <p className="address__mobile-text ui text size-text2xl">
                    {e.addressLine2} {e.city}, {e.state}-{e.pinCode},{" "}
                    {e.country}
                  </p>
                </div>
                <p className="address__mobile-text ui text size-text2xl">
                  <span>Mobile:&nbsp;</span>
                  <span className="address__delivery-date-span">
                    {e.mobileNumber || "N/A"}
                  </span>
                </p>
              </div>
              <div className="address__action-row">
                <button
                  className="flex-row-center-center address__remove-button ui button white_a700 size-lg fill"
                  onClick={() => handleRemoveAddress(e._id)}
                >
                  REMOVE
                </button>
                <button
                  className="flex-row-center-center address__edit-button ui button white_a700 size-lg fill"
                  onClick={() => handleEditAddress(e._id)}
                >
                  EDIT
                </button>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>No addresses found.</p>
      )}

      {isModalOpen && (
        <AddressModal
          visible={isModalOpen}
          onClose={handleModalClose}
          onSave={handleSaveAddress}
          formData={formData}
          setFormData={setFormData}
          id={editAddress}
        />
      )}
    </div>
  );
}

export default AddressDetails;